import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-circle-fill text-xl"></i>
            </div>
            <span className={`text-xl font-bold transition-colors ${isScrolled || !isHome ? "text-foreground-900" : "text-white"}`}>
              久久视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled || !isHome
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索视频..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border transition-colors w-48 focus:w-64 focus:outline-none ${
                  isScrolled || !isHome
                    ? "bg-background-100 border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400"
                    : "bg-white/10 border-white/20 text-white placeholder:text-white/50 focus:border-white/50 focus:bg-white/20"
                }`}
              />
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${isScrolled || !isHome ? "text-foreground-400" : "text-white/50"}`}></i>
            </div>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${isScrolled || !isHome ? "text-foreground-900" : "text-white"}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={isMobileMenuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors"
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors"
            >
              <i className="ri-information-line mr-2"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}